export default "__VITE_ASSET__000c0b08__"